import React from 'react';
import AppInstallContext from '.';
import BeforeInstallPromptEvent from './BeforeInstallPromptEvent';

export default function AppInstallContextProvider(props: {children: React.ReactNode}) {
  const { children } = props;

  React.useEffect(() => {
  }, []);
  const [event, setEvent] = React.useState<BeforeInstallPromptEvent | null>(null);

  React.useEffect(() => {
    const listener = (e: BeforeInstallPromptEvent) => {
      e.preventDefault();
      setEvent(e);
    };
    window.addEventListener('beforeinstallprompt', listener);
    return () => { window.removeEventListener('beforeinstallprompt', listener); };
  }, []);

  const install = React.useMemo(() => {
    if (!event) return undefined;
    return () => {
      event.prompt();
      return event.userChoice.then(({ outcome }) => {
        setEvent(null);
        return outcome === 'accepted' || true;
      });
    };
  }, [event]);

  const value = React.useMemo(() => ({
    install,
  }), [install]);

  return (
    <AppInstallContext.Provider value={value}>
      {children}
    </AppInstallContext.Provider>
  );
}
